import { Locales } from '@griply/types';
import deDE from 'date-fns/locale/de';
import enUS from 'date-fns/locale/en-US';
import esES from 'date-fns/locale/es';
import nlNL from 'date-fns/locale/nl';
import React from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { useI18nLocale } from 'shared/lib/react-i18next/use-i18n-locale';
import { WeekDays } from 'shared/types/week-days';

// @ts-ignore
registerLocale(Locales.EnUS, enUS);
// @ts-ignore
registerLocale(Locales.NlNL, nlNL);
// @ts-ignore
registerLocale(Locales.EsES, esES);
// @ts-ignore
registerLocale(Locales.DeDE, deDE);

const weekDaysToNumbers: Record<WeekDays, number> = {
  [WeekDays.Monday]: 1,
  [WeekDays.Tuesday]: 2,
  [WeekDays.Wednesday]: 3,
  [WeekDays.Thursday]: 4,
  [WeekDays.Friday]: 5,
  [WeekDays.Saturday]: 6,
  [WeekDays.Sunday]: 0,
};

export type ReactDatePickerProps = Omit<
  React.ComponentProps<typeof DatePicker>,
  'popperClassName' | 'calendarStartDay' | 'locale'
> & {
  className?: string;
  weekStartsOn?: WeekDays;
};

export const ReactDatePicker: React.FC<ReactDatePickerProps> = ({
  className,
  weekStartsOn,
  ...rest
}) => {
  const locale = useI18nLocale();

  return (
    <DatePicker
      popperClassName={className}
      calendarStartDay={
        weekStartsOn ? weekDaysToNumbers[weekStartsOn] : undefined
      }
      locale={locale}
      {...rest}
    />
  );
};
